import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Cascader, Select } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import SelectProvince from '../../../common/SelectProvince';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import { generateOptions } from '../../../shared/selectFn';
import { DisplayType } from '../../constants/common';

const { Option } = Select;
const displayTypeOption = generateOptions(DisplayType);
const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology',
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy',
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy',
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy',
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant',
                label: '器官移植',
            },
            {
                value: 'Gene_therapy',
                label: '基因治疗',
            },
            {
                value: 'Dialysis',
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]
class ChartFilter extends Component {
    static contextTypes = {
        activeKey: PropTypes.string,
        business: PropTypes.array,
        contractType: PropTypes.array,
        systemDate: PropTypes.object,
        isSeniorUserBo: PropTypes.bool,
        FINANCE_INDICATOR_ANALYSIS: PropTypes.bool,
        isDesignatedTal: PropTypes.bool,
        isLineCharge: PropTypes.bool,
    }

    // 判断是否仅满足 isDesignatedTal 条件（其他权限条件均不满足）
    isOnlyDesignatedTal = () => {
        const { isSeniorUserBo, FINANCE_INDICATOR_ANALYSIS, isDesignatedTal, isLineCharge } = this.context;
        const curRole = sessionStorage.curRole;
        return isDesignatedTal && curRole !== 'FIN' && !isSeniorUserBo && !FINANCE_INDICATOR_ANALYSIS && !isLineCharge;
    }

    handleChange = (value, key) => {
        const { params, onChange } = this.props;
        switch (key) {
            case 'lineOfBusiness': {
                if ((value || []).length === 0) {
                    return;
                }
                params.lineOfBusiness = (value || []).length ? value.join(',') : '';
                params.displayType = 'Difference';
                break;
            }
            case 'contractTypeId': {
                if ((value || []).length === 0) {
                    return;
                }
                params.contractTypeId = (value || []).length ? value.join(',') : '';
                break;
            }
            case 'talUser': {
                const { value: id, text: name } = value;
                params[`${key}Id`] = id;
                params[`${key}Name`] = name;
                break;
            }
            case 'province': {
                const areaParams = {};
                const areaList = [];
                const hasCheckedArea = [];
                value.forEach(item => {
                    const { key, props: { title } = {} } = item || {};
                    areaParams[`params[${title}]`] = key;
                    areaList.push(title);
                    hasCheckedArea.push(key);
                });
                params.areaParams = areaParams;
                params.hasCheckedArea = hasCheckedArea;
                params.areaName = areaList.join(',');
                break;
            }
            default:
                params[key] = value;
                break;
        }
        onChange(params);
    }

    render() {
        const { activeKey, business, contractType, systemDate: { trueYear } } = this.context;
        const { params, onSearch, onExport } = this.props;
        const businessOption = business.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const contractTypeOption = contractType.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const statisticsDateOption = [];
        for (let start = 2021, end = trueYear || 2021; start <= end; start++) {
            statisticsDateOption.push(<Option key={start}>{start}</Option>);
        }
        const medicineTypeOptions = MedicineTypeList.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        const onlyDesignatedTal = this.isOnlyDesignatedTal();
        return (
            <div className="filter-wrap" style={{ marginBottom: 10, padding: 10, background: '#fff' }}>
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">业务线</label>
                    <Select
                        mode="multiple"
                        placeholder="请选择"
                        className="multiple-stage"
                        value={format('toArray', params.lineOfBusiness)}
                        style={{ width: 110, verticalAlign: 'middle' }}
                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>
                {
                    params.lineOfBusiness == -1 &&
                    <div className="filter-item">
                        <label htmlFor="" className="filter-label">统计形式</label>
                        <Select
                            placeholder="请选择"
                            value={format('toString', params.displayType)}
                            style={{ width: 140, verticalAlign: 'middle' }}
                            onChange={value => this.handleChange(value, 'displayType')}
                        >
                            {displayTypeOption}
                        </Select>
                    </div>
                }
                {
                    activeKey !== 'centerIncome' &&
                    <div className="filter-item">
                        <label htmlFor="" className="filter-label">计收入确认方式</label>
                        <Select
                            mode="multiple"
                            placeholder="请选择"
                            className="multiple-stage"
                            value={format('toArray', params.contractTypeId)}
                            style={{ width: 110, verticalAlign: 'middle' }}
                            onChange={value => this.handleChange(value, 'contractTypeId')}
                        >
                            {contractTypeOption}
                        </Select>
                    </div>
                }
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">研究产品类型</label>
                    {/* <Select
                        placeholder="请选择"
                        style={{ width: 130 }}
                        allowClear={true}
                        value={params.investigationMedicineType}
                        onChange={value => this.handleChange(value, 'investigationMedicineType')}
                    >
                        {medicineTypeOptions}
                    </Select> */}
                    <Cascader
                        allowClear={true}
                        style={{ width: 130 }}
                        placeholder="请选择"
                        options={MedicineTypeList}
                        value={params.investigationMedicineType}
                        onChange={value => this.handleChange(value, 'investigationMedicineType')}
                    />
                </div>
                {
                    activeKey === 'centerIncome' &&
                    <div className="filter-item">
                        <label className="filter-label">区域/城市</label>
                        <SelectProvince
                            areaName={params.areaName || ''}
                            saveProvince={value => this.handleChange(value, 'province')}
                            hasCheckedArea={params.hasCheckedArea || []}
                            style={{verticalAlign: 'middle'}}
                        />
                    </div>
                }
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">领域leader</label>
                    <SearchRetrieve
                        keyword='leaderName'
                        style={{ width: 140 }}
                        placeholder="输入姓名/工号检索"
                        value={params.talUserName}
                        params={{ limit: 20, status: 'ALL' }}
                        url={API_URL.user.queryLeaderList}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={value => this.handleChange(value, 'talUser')}
                        disabled={onlyDesignatedTal}
                    />
                </div>
                <div className="filter-item">
                    <label className="filter-label">统计时间</label>
                    <Select
                        placeholder="请选择"
                        value={format('toString', params.year)}
                        style={{ width: 80, verticalAlign: 'middle' }}
                        onChange={value => this.handleChange(value, 'year')}
                    >
                        {statisticsDateOption}
                    </Select>
                </div>
                <div className="filter-item" >
                    <Button type="primary" onClick={onSearch}>统计</Button>
                    <Button className="btn-yellow" style={{ marginLeft: 10 }} onClick={onExport}>明细导出</Button>
                </div>
            </div>
        );
    }
}

export default ChartFilter;



// WEBPACK FOOTER //
// ./src/components/homePage/FinanceIndicatorAnalysis/components/ChartFilter.js